// extracted by mini-css-extract-plugin
export var childrenContainer = "_70-0";
export var virtualScrollArea = "_70-1";